module.exports = __webpack_public_path__ + "img/logo_fundacion_pcshek.c6f7de38.png";